import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AranDrawerModalService } from '@aran-client/aran-web-ui-toolkit';
import { Store } from '@ngxs/store';
import { Observable, tap } from 'rxjs';
import { appInfo } from 'src/app/shared/constants/app-info.constant';
import { routeMetaData } from 'src/app/shared/constants/route-metadata.constant';
import { StoreHelperService } from 'src/app/shared/services/store-helper/store-helper.service';
import * as apiInstructionTypes from 'src/app/shared/types/api-instruction.type';
import { ApiInstructionAction } from 'src/app/store/api-instruction/api-instruction.action';
import { ApiInstructionState } from 'src/app/store/api-instruction/api-instruction.state';

@Component({
  selector: 'app-api-instruction',
  templateUrl: './api-instruction.component.html',
  styleUrls: ['./api-instruction.component.scss'],
})
export class ApiInstructionComponent implements OnInit {
  @ViewChild('setApiPassword') setApiPassword!: TemplateRef<any>;
  @ViewChild('authAndAccessTemplate')
  authAndAccessTemplate!: TemplateRef<any>;
  @ViewChild('aeronauticalInformationTemplate')
  aeronauticalInformationTemplate!: TemplateRef<any>;
  @ViewChild('digitalNotamTemplate')
  digitalNotamTemplate!: TemplateRef<any>;

  routeMetaData = routeMetaData;
  appInfo = appInfo;

  accessAndUseTabs: any[] = [];
  selectedIndex: number = 0;

  currentTemplate!: TemplateRef<any>;
  modalTitle: string = '';

  isLoading$: Observable<boolean> = this.store.select(
    ApiInstructionState.getIsLoading()
  );

  isExistApi: boolean | undefined = false;

  accessAndUseData: apiInstructionTypes.DetailInfo | null = null;

  constructor(
    private store: Store,
    private aranDrawerModalService: AranDrawerModalService,
    private storeHelperService: StoreHelperService
  ) {}

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails(): void {
    this.storeHelperService
      .getAllDispatchAndSelect(
        new ApiInstructionAction.GetDetailInfo(),
        ApiInstructionState.getApiInfo
      )
      .pipe(
        tap((data) => {
          this.accessAndUseData = data;
          this.isExistApi = data?.hasPassword;

          this.accessAndUseTabs = [
            {
              label: 'Authentication and Access',
              template: this.authAndAccessTemplate,
            },
            ...(data?.aeronauticalInformationInfo?.isEnabled
              ? [
                  {
                    label: 'Aeronautical Information',
                    template: this.aeronauticalInformationTemplate,
                  },
                ]
              : []),
            ...(data?.digitalNotamInfo?.isEnabled
              ? [
                  {
                    label: 'Digital NOTAM',
                    template: this.digitalNotamTemplate,
                  },
                ]
              : []),
          ];
        })
      )
      .subscribe();
  }
  generate() {
    this.modalTitle = this.isExistApi
      ? 'Reset API Password'
      : 'Generate API Password';
    this.currentTemplate = this.setApiPassword;
    this.aranDrawerModalService.show();
  }

  onTabChanged(index: number) {
    this.selectedIndex = index;
  }
}
